export const LIVE_CHAT_LICENSE = '12092754';
